import React from "react"
import { ConfiguracaoFiscalContextProvider } from "./context/ConfiguracaoFiscalContextProvider"
import { ConfiguracaoFiscal } from "./ConfiguracaoFiscal"

export function Index() {
    return (
        <ConfiguracaoFiscalContextProvider>
            <ConfiguracaoFiscal />
        </ConfiguracaoFiscalContextProvider>
    )
}
